import React from 'react';
import WidgetAnnotationModal from './WidgetAnnotationModal';

const ReportModal = (props) => {
  return (<WidgetAnnotationModal
    modelType="report"
    baseUrlLabel="Standard Report"
    {...props}
  />);
};

export default ReportModal;
